import React from 'react';
import { Wrapper } from '../shared/commonStyles';
import Title from '../title/Title';
import ProductCard from '../card/ProductCard';

import Image1 from '../../assets/image/original_dress/wands.png'

const SectionCollaborationDress = () => {
    const url = "https://weddingdress.pla-cole.wedding/c/original/original_dress"
    const buttonText = '限定ドレスをみる'

    const description1 = "Wands wants to be one’s special."
    const description2 = "まるで魔法の杖“wand”のように\n着る人や空間に魔法をかけるウェディングドレス。\n誰かの特別な1着になることを願ってデザインしています。"
    const description3 = "PLACOLE & DRESSYがユーザーの声をデザインに取り入れ、\nデザイン性と価格のバランスに優れた、\n高品質なドレスをお届けします。"

    const descriptionArray = [
        description1,
        description2,
        description3,
    ]

    return (
      <Wrapper id="original-dress">
        <Title 
            title={"PLACOLE & DRESSY\nBRAND LIMITED DRESS"}
            subTitle={"オリジナルドレス"}    
        />
        <ProductCard 
            title={"Wands-ワンズ-"}
            image={Image1}
            description={descriptionArray}
            url={url}
            buttonText={buttonText}
        />
      </Wrapper>
    );
  };
  
export default SectionCollaborationDress;
  